class UserAuth {
  constructor(client) {
    this.client = client
  }

  getUid() {
    return this.client.getUid()
  }

  async createUser(email, password) {
    return await this.client.createUser(email, password)
  }

  async deleteUser() {
    return await this.client.deleteUser()
  }

  async reauthenticate(email, password) {
    return await this.client.reauthenticate(email, password)
  }

  async signIn(email, password) {
    return await this.client.signIn(email, password)
  }

  async signOut() {
    return await this.client.signOut()
  }

  async sendEmailVerification(url) {
    return await this.client.sendEmailVerification(url)
  }

  async sendPasswordResetEmail(email) {
    return await this.client.sendPasswordResetEmail(email)
  }

}

export { UserAuth }
